<script setup lang="ts">
  import { ICharacterCdn } from '@/store/ClassesJobs'
  import { PropType } from 'vue'

  const basicInfo = {
    type: 'Origin',
    movement: 'Movement',
    mainStat: 'Main Stat',
  } as const

  type BasicInfoKey = keyof typeof basicInfo

  const props = defineProps({
    characterData: {
      type: Object as PropType<ICharacterCdn>,
      required: true,
    },
  })
</script>
<template>
  <div class="cj-basic-info">
    <div
      class="cj-basic-info__item"
      v-for="key in Object.keys(basicInfo)"
      :key="key"
      :class="`cj-basic-info__item--${key}`"
    >
      <div class="cj-basic-info__item-title">{{ basicInfo[key as BasicInfoKey] }}</div>
      <div class="cj-basic-info__item-value">{{ props.characterData[key as keyof ICharacterCdn] }}</div>
    </div>
  </div>
</template>
<style lang="scss" scoped>
  $imgPath: '@/assets/imgs/classesJobs';
  $imgs-map: (
    type: 'cj-basic-origin.png',
    movement: 'cj-basic-movement.png',
    mainStat: 'cj-basic-main.png',
  );
  .cj-basic-info {
    margin-top: pxToRem(45px);
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: pxToRem(35px);
  }

  @each $key, $file in $imgs-map {
    .cj-basic-info__item--#{$key} {
      .cj-basic-info__item-title {
        &:before {
          background-image: url(#{$imgPath}/basic-info/#{$file});
        }
      }
    }
  }
  .cj-basic-info__item {
    background: #ffa922;
    width: pxToRem(435px);
    height: pxToRem(50px);
    display: flex;
    font-family: Glegoo;
    font-size: pxToRem(17px);
  }
  .cj-basic-info__item-title {
    font-weight: bold;
    position: relative;
    flex: 0 0 35%;
    background: #4b4137;
    color: white;
    padding-left: pxToRem(55px);
    display: flex;
    align-items: center;
    &:before {
      content: '';
      position: absolute;
      left: pxToRem(16px);
      top: 50%;
      transform: translateY(-50%);
      width: pxToRem(22px);
      height: pxToRem(41.325px);
      background: no-repeat center center / 100% auto;
    }
    &:after {
      content: '';
      position: absolute;
      right: 0;
      transform: translateX(100%) rotate(0deg);
      width: 0px;
      height: 0px;
      border-style: solid;
      border-width: pxToRem(24px) 0 pxToRem(24px) pxToRem(18px);
      border-color: transparent transparent transparent #4b4137;
    }
  }
  .cj-basic-info__item-value {
    display: flex;
    align-items: center;
    padding-left: pxToRem(50px);
  }
  @media #{$tablet} {
    .cj-basic-info {
      margin-top: pxToRemTablet(0);
      gap: pxToRemTablet(35px);
    }
    .cj-basic-info__item {
      width: pxToRemTablet(435px);
      height: pxToRemTablet(50px);
      font-size: pxToRemTablet(18px);
    }
    .cj-basic-info__item-title {
      background: #4b4137;
      padding-left: pxToRemTablet(55px);
      &:before {
        left: pxToRemTablet(16px);
        transform: translateY(-50%);
        width: pxToRemTablet(22px);
        height: pxToRemTablet(41.325px);
      }
      &:after {
        border-width: pxToRemTablet(24px) 0 pxToRemTablet(24px) pxToRemTablet(18px);
      }
    }
    .cj-basic-info__item-value {
      padding-left: pxToRemTablet(50px);
    }
  }

  @media #{$mobile} {
    .cj-basic-info {
      margin-top: pxToRemMobile(45px);
      gap: pxToRemMobile(35px);
    }
    .cj-basic-info__item {
      width: pxToRemMobile(435px);
      height: pxToRemMobile(50px);
      font-size: pxToRemMobile(16.125px);
    }
    .cj-basic-info__item-title {
      background: #4b4137;
      padding-left: pxToRemMobile(55px);
      &:before {
        left: pxToRemMobile(16px);
        transform: translateY(-50%);
        width: pxToRemMobile(22px);
        height: pxToRemMobile(41.325px);
      }
      &:after {
        border-width: pxToRemMobile(24px) 0 pxToRemMobile(24px) pxToRemMobile(18px);
      }
    }
    .cj-basic-info__item-value {
      padding-left: pxToRemMobile(50px);
    }
  }
</style>
